import store from "@/store";

export const redirectIfAuthenticated = (to: any, from: any, next: any) => {
  if (store.getters.isAuthenticated) {
    return next("/panel-facto/estadisticas");
  }
  next();
};

export const authenticationRequired = (to: any, from: any, next: any) => {
  if (store.getters.isAuthenticated) {
    if (to.path.startsWith("/panel-facto/")) {
      //@ts-ignore
      store.state.menu = 3;
    }
    next();
  } else {
    store.commit("clearSession");
    next(`/login?return=${to.path}`);
  }
};
